export const aciCreditCard = {
    iconName: 'credit-card',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M21.026 3H2.474A2.481 2.481 0 000 5.474V18.09a2.48 2.48 0 002.474 2.473h18.552A2.48 2.48 0 0023.5 18.09V5.474A2.48 2.48 0 0021.026 3zM2.474 4.237h18.552c.743 0 1.237.495 1.237 1.237v1.979H1.237v-1.98c0-.741.495-1.236 1.237-1.236zm18.552 15.09H2.474c-.742 0-1.237-.495-1.237-1.237v-9.4h21.026v9.4c0 .742-.494 1.236-1.237 1.236z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M13.235 11.905H5.072c-.371 0-.618.248-.618.619 0 .37.247.618.618.618h8.163c.371 0 .619-.247.619-.618s-.248-.619-.619-.619zM10.267 14.874H5.072c-.371 0-.618.247-.618.618s.247.619.618.619h5.195c.37 0 .618-.248.618-.619 0-.37-.247-.618-.618-.618z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
